import React from 'react';

const Icon = ({ title, icon, ...props }) => {
  return <img {...props} alt={title} src={icon} />;
};

export default Icon;
